export { default } from "./LayoutClientErrorFooter";
